// extracted by mini-css-extract-plugin
export default {"title":"CocktailsAddingPage_title__vvb5k","actions":"CocktailsAddingPage_actions__ISZ-S"};